import axios from "axios";
import { SagaIterator } from "redux-saga";
import { call, cancelled, put, takeLatest } from "redux-saga/effects";

import { callGet } from "../../http_client";
import { createGenerateReportHandler } from "../reports/sagas";

import {
  bookingsFetchError,
  bookingsFetchRequest,
  bookingsFetchSuccess,
  reportGeneratorTaskCreateRequest,
} from "./actions";
import { BookingsActionTypes } from "./types";

export function* handleBookingsFetch(action: ReturnType<typeof bookingsFetchRequest>): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const res = yield call(callGet, "/bookings/", action.payload, source.token);
    yield put(bookingsFetchSuccess(res.data));
  } catch (err) {
    yield put(bookingsFetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

const handleBookingsReportFetch = createGenerateReportHandler<ReturnType<typeof reportGeneratorTaskCreateRequest>>(
  "/bookings/report/"
);

function* watchBookingsSagas(): SagaIterator {
  yield takeLatest(BookingsActionTypes.DATA_FETCH_REQUEST, handleBookingsFetch);
  yield takeLatest(BookingsActionTypes.GENERATE_REPORT_REQUEST, handleBookingsReportFetch);
}

export default watchBookingsSagas;
